var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.255859,
    width: 41.4887,
    height: 41.4887,
    rx: 18.3003,
    fill: "#F4A51D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8911 13.1413C20.2855 12.4858 21.2358 12.4858 21.6303 13.1413L23.6013 16.4165C23.743 16.652 23.9742 16.8199 24.2419 16.8819L27.9659 17.7444C28.7112 17.917 29.0049 18.8208 28.5034 19.3985L25.9976 22.2852C25.8174 22.4927 25.7291 22.7645 25.7529 23.0383L26.0834 26.8465C26.1495 27.6087 25.3807 28.1673 24.6763 27.8688L21.1566 26.3777C20.9035 26.2705 20.6178 26.2705 20.3647 26.3777L16.845 27.8688C16.1406 28.1673 15.3718 27.6087 15.4379 26.8465L15.7684 23.0383C15.7922 22.7645 15.7039 22.4927 15.5238 22.2852L13.0179 19.3985C12.5164 18.8208 12.8101 17.917 13.5554 17.7444L17.2794 16.8819C17.5471 16.8199 17.7783 16.652 17.92 16.4165L19.8911 13.1413Z",
    fill: "#F4A51D",
    stroke: "#F4A51D",
    strokeWidth: 1.26868
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.33f2c8cf33945430b97b7231f868c18b.svg";
export { ForwardRef as ReactComponent };